import creatorComponent from './creator.component';
import creatorDataComponent from './data.component';

const imomoMeteostationCreatorModule = angular.module('imomo.meteostation.creator', [])
    .component('imomoMeteostationCreator', creatorComponent)
    .component('imomoMeteostationCreatorData', creatorDataComponent);

export default imomoMeteostationCreatorModule;



/** WEBPACK FOOTER **
 ** ./app/meteostation/creator/creator.module.ts
 **/